<template lang="pug">
.entity-path-selector
  v-autocomplete(
    v-bind="{ disabled }"
    v-model="field",
    :label="label",
    :items="enabledFields",
    item-text="name",
    :error-messages="errors",
    return-object,
    :append-outer-icon="clearable ? 'mdi-close' : null"
    @click:append-outer="reset"
  )
</template>

<style lang="scss" scoped>
.entity-path-selector {
  ::v-deep .v-label {
    color: var(--v-text-base);
    font-weight: 800;
    font-family: "Avenir LT", "Roboto", sans-serif;
    font-size: 13px;
  }
}
</style>

<script>
import EntityMixin from '@/mixins'
import _ from 'lodash'
export default {
  mixins: [EntityMixin],
  props: ['entity', 'extraItems', 'initial', 'title', 'clearable', 'disabled', 'errors', 'noMultipleFields'],
  data () {
    return {
      field: null,
      path: [],
    }
  },
  methods: {
    reset() {
      this.field = null
      this.path = []
    },
    getCompletePath() {
      let fields = this.initial.split('.')
      for (var i = 0; i < fields.length; i++) {
        this.field = this.entitySelected.fields.find(f => f.name == fields[i])
        if(fields.length - 1 != i)
          this.path.push(this.field)
      }
    },
  },
  watch: {
    field (newValue) {
      if(newValue == null) return
      this.path.push(newValue)
      this.$emit('path',  { path: this.path.map(f => f.name).join('.'), field: this.field })
      if (this.field.primitive) {
        this.$emit('field',  { path: this.path.map(f => f.name).join('.'), field: this.field })
      }
    }
  },
  computed: {
    enabledFields() {
      let items = _.cloneDeep(this.fieldItems);

      items.map(f => f.disabled ? {...f, disabled: false} : f);
      let externalIdField = items.filter(x => x.name == "externalId");
      let nativeFields = items.filter(x => !x.extra)
        .sort((a, b) => a.name.localeCompare(b.name));
      let extraFields = items.filter(x => x.extra);
      return [].concat(externalIdField, nativeFields, extraFields);
    },
    fieldItems () {
      if(this.noMultipleFields && this.noMultipleFields == true)
        return (this.entitySelected||{ fields: [] }).fields.filter(x => x.multiple == false && !x.notFilterable);
      return (this.entitySelected||{ fields: [] }).fields.filter(x => !x.notFilterable);
    },
    entitySelected () {
      return this.field === null
        ? this.entity
        : this.$findEntity(this.field.type)
    },
    label() {
      return _.isEmpty(this.path) ? this.title : this.path.map(f => f.name).join('.');
    },
  },
  mounted () {
    if (this.initial) {
      if (!this.initial.includes('.'))
        this.field = this.entitySelected.fields.find(f => f.name == this.initial)
      else
        this.getCompletePath()
    }
  }
}
</script>
